import Api from '@/api/index';

export default {
  namespaced: true,
  state: {
    allPayOpts: null,
    allPayTimes: null,
  },
  mutations: {
    getPayModal(state, {payModal, type}){
      if (type == 'options'){
        state.allPayOpts = payModal.data;
      }else if (type == 'times'){
        state.allPayTimes = payModal.data;
      }
    },
    clearAllPaymentOptions(state, type){
      if (type == 'options'){
        state.allPayOpts = null;
      }else if (type == 'times'){
        state.allPayTimes = null;
      }
    },
  },
  actions: {
    index(context, type){
      Api.PaymentOption.index(type)
        .then(response => response.data)
        .then(paymentOption => {
          context.commit('getPayModal', {payModal: paymentOption, type: type})
        }).catch(function(error) {
          console.log(error);
        })
    },
    clearAllPaymentOptions(context, type){
      context.commit('clearAllPaymentOptions', type)
    },
  }
};
